export default "__VITE_ASSET__vFshxZAl__"